//@ts-nocheck
import {
  Divider,
  Button,
  Form,
  Grid,
  Input,
  Text,
  Dimmer,
} from '@wework/dieter-ui'
import { withFloorMap } from '@wework/react-floormap'
import React, { useEffect, useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'
import { CheckIcon, Lock } from '../Icons'
import { Loader, Radio } from 'semantic-ui-react'

import EditPhysicalSpaceMeetingRoom from './EditPhysicalSpaceMeetingRoom'
import EditPhysicalSpaceOffice from './EditPhysicalSpaceOffice'
import EditSpaceLoadImageModal from './EditSpaceLoadImageModal'
import EditSpaceDeleteImageModal from './EditSpaceDeleteImageModal'
import IMTheme from '../../style/IMTheme'

import DragNDroopFile from '../Common/DragNDropFile'
import compose from '../../utils/compose'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import SATextHolder from './SATextHolder'

function EditSpaceAttributes({
  space,
  roomData,
  setRoomData,
  floorMap,
  snackBars,
}) {
  const [obstructions, setObstructions] = useState<any>(
    roomData?.obstructions > 0
  )
  const [isLoadImageOpen, setIsLoadImageOpen] = useState<boolean>(false)
  const [isDeleteImageOpen, setIsDeleteImageOpen] = useState<boolean>(false)
  const { openSideBar } = useSidebar()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [imgUrl, setImageUrl] = useState<string | null>()
  const [imgFile, setImageFile] = useState<File | null>()
  const imageId = ''
  const inventoryId =
    space.inventoryData?.relationships &&
    space.inventoryData?.relationships.length > 0 &&
    space.inventoryData?.relationships[0].id

  useEffect(() => {
    if (roomData) {
      setObstructions(roomData?.obstructions > 0)
    }
  }, [roomData, roomData?.obstructions])

  useEffect(() => {
    if (!obstructions) {
      setRoomData({ ...roomData, obstructions: 0 })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [obstructions])
  const getEditingMeetingRoomSection = () => {
    switch (space?.programType) {
      case 'MEET':
        return (
          <EditPhysicalSpaceMeetingRoom
            space={space}
            setShowLinkeage={() => openSideBar('Linkeage')}
            roomData={roomData}
            setRoomData={setRoomData}
          />
        )
      case 'WORK':
        if (space.roomType === 'CHAIR') {
          return <p></p>
        } else {
          return (
            <EditPhysicalSpaceOffice
              space={space}
              setShowLinkeage={() => openSideBar('Linkeage')}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          )
        }
      default:
        return <p></p>
    }
  }

  const handleLoadImage = async () => {
    const inventoryExtension = floorMap.getExtension('inventoryData')
    if (imgUrl) {
      try {
        const name = imgUrl.split('/').pop()
        setIsLoading(true)
        const imgExt = imgUrl.split('.').pop()
        await inventoryExtension.addImageURL(inventoryId, name, imgExt, imgUrl)
        snackBars.addAlert({ text: 'Image loaded', variant: 'success' })
        onClose(true)
      } catch (exception) {
        snackBars.addAlert({ text: exception.message, variant: 'error' })
      } finally {
        setIsLoading(false)
      }
    } else if (imgFile) {
      const reader = new FileReader()
      reader.onload = async e => {
        try {
          setIsLoading(true)
          const encodeFile = e.target?.result
            ?.toString()
            .split('base64,')
            .pop()
          const imgExt = imgFile.name.split('.').pop()
          await inventoryExtension.addImageFile(
            inventoryId,
            imgFile.name,
            imgExt,
            encodeFile
          )
          snackBars.addAlert({ text: 'Image loaded', variant: 'success' })
          onClose(true)
        } catch (exception) {
          snackBars.addAlert({ text: exception.message, variant: 'error' })
        } finally {
          setIsLoading(false)
        }
      }
      reader.readAsDataURL(imgFile)
    }
  }

  if (!roomData) {
    return null
  }

  const changeRoomData = (_event, data: { checked: boolean }) => {
    if (!roomData) return
    setRoomData(prev => ({
      ...prev,
      sellable_bookable: data.checked,
    }))
  }

  return (
    <div>
      {inventoryId && (
        <>
          <EditSpaceLoadImageModal
            inventoryId={inventoryId}
            open={isLoadImageOpen}
            onClose={() => setIsLoadImageOpen(false)}
          />
          {imageId && (
            <EditSpaceDeleteImageModal
              imageId={imageId}
              open={isDeleteImageOpen}
              onClose={() => setIsDeleteImageOpen(false)}
            />
          )}
        </>
      )}
      <Grid>
        <Grid.Column width={8}>
          <div>
            <SATextHolder
              title="Is this space sellable or bookable?"
              text="Space that can be sold or booked needs to be linked with an inventory inventory."
            />
          </div>
        </Grid.Column>
        <Grid.Column
          width={8}
          style={{
            width: '50%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Radio
            checked={roomData.sellable_bookable}
            label={roomData.sellable_bookable ? 'Yes' : 'No'}
            toggle
            onChange={changeRoomData}
          />
        </Grid.Column>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8}>
            <SATextHolder
              title="Number of seats?"
              text="How many seats are there physically in this space?. To change the capacity, please request it here."
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Group widths="equal">
              <Form.Field
                label="Seat count"
                control={Input}
                type="number"
                size="small"
                disabled={!roomData?.seat_count?.toString()}
                value={roomData?.seat_count?.toString()}
                onChange={(e, data) => {
                  //@ts-ignore
                  if (data?.value > 0) {
                    setRoomData({
                      ...roomData,
                      //@ts-ignore
                      seat_count: parseInt(data?.value?.toString()),
                    })
                  }
                }}
                outline
                fluid
                style={{ marginBottom: 24 }}
              />
              <Form.Field
                label="Capacity"
                control={Input}
                disabled
                type="number"
                size="small"
                value={roomData?.seat_count?.toString()}
                onChange={(e, data) => {
                  //@ts-ignore
                  if (data?.value > 0) {
                    setRoomData({
                      ...roomData,
                      //@ts-ignore
                      seat_count: parseInt(data?.value?.toString()),
                    })
                  }
                }}
                className="noOpacity"
                outline
                fluid
                style={{ marginBottom: 24 }}
                icon={
                  <div
                    style={{
                      position: 'absolute',
                      right: 5,
                      top: 10,
                      cursor: 'pointer',
                    }}
                  >
                    <Button
                      icon={<Lock />}
                      style={{ padding: 0, background: 'white' }}
                    />
                  </div>
                }
              />
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <SATextHolder
                title="Size of the space"
                text="How big is this space? To change the size, please request it here."
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              label="Size in ft"
              control={Input}
              outline
              defaultValue={roomData.usable_sqft}
              value={roomData.usable_sqft}
              icon={
                <div
                  style={{
                    position: 'absolute',
                    right: 5,
                    top: 10,
                    cursor: 'pointer',
                  }}
                >
                  <Button
                    icon={<Lock />}
                    style={{ padding: 0, background: 'white' }}
                  />
                </div>
              }
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      {inventoryId && (
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <SATextHolder
                title="Photo of this space"
                text="A photo of how this space looks like."
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <DragNDroopFile
                onDrop={acceptedFiles => {
                  if (acceptedFiles[0]) {
                    setImageFile(acceptedFiles[0])
                    if (imgUrl) {
                      setImageUrl(null)
                    }
                  } else {
                    setImageFile(null)
                  }
                }}
                multiple={false}
                accept=".jpeg, .jpg, .png, .gif, .bmp"
              />
              <Text
                style={{
                  marginTop: IMTheme.spacing[4],
                  fontSize: IMTheme.fontSizes[1],
                  color: IMTheme.colors.darkGray,
                }}
              >
                Alternatively, you can also add using an image url.
              </Text>
              <Grid.Row style={{ marginTop: IMTheme.spacing[4] }}>
                <Form style={{ width: '100%' }}>
                  <Form.Field
                    id="imageUrl"
                    type="text"
                    placeholder="Image URL"
                    control={Input}
                    onChange={e => {
                      //@ts-ignore
                      setImageUrl(e.target.value || '')
                      if (imgFile) {
                        setImageFile(null)
                      }
                    }}
                  />
                </Form>
                <Button
                  basic
                  active={true}
                  disabled={!imgUrl && !imgFile}
                  style={{
                    width: 40,
                    height: 40,
                    marginLeft: IMTheme.spacing[2],
                  }}
                  onClick={handleLoadImage}
                  icon={<CheckIcon />}
                />
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      {getEditingMeetingRoomSection()}
    </div>
  )
}

export default compose(withFloorMap())(withSnackbar(EditSpaceAttributes))
